





















































































import { PipelinePublishTask } from '@/api/com/MetaPattern/APP/MDA/Pipeline/PipelinePublishTask';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ProductPipelineSettingDTO } from './ProductPipelineSetting.vue';
import { DateHelper } from '@/libs/com/MetaPattern/Product/IDE/Util/TypeUtil';
import { EnumPipelineHandleStatus, EnumPipelineHandleStatusMD } from '@/api/com/MetaPattern/APP/MDA/Pipeline/EnumPipelineHandleStatus';
import { PipelinePublishPhase } from '@/api/com/MetaPattern/APP/MDA/Pipeline/PipelinePublishPhase';
import { PipelineService } from '@/api/com/MetaPattern/APP/MDA/Pipeline/PipelineService';
import { Dictionary } from '@/libs/com/MetaPattern/Product/IDE/Util/Dictionary';
import { APP } from '@/api/com/MetaPattern/MDA/MD/Base/APP';

class Node {
  public id: string;
  public type: string;
  public size: string;
  public timestamp: string;
  public name: string;
  public description: string;
  public errorMessage: string;
  public phase: PipelinePublishPhase;
  public children: Array<Node>;

  constructor(phase: PipelinePublishPhase) {
    if (phase !== null) {
      this.phase = phase;
      this.id = phase.id;
      this.timestamp = this.getPhaseDateString();
      this.name = phase.name;
      this.type = this.getPhaseTypeString();
      this.description = phase.description;
      if (phase.publishStatus === EnumPipelineHandleStatus.Fail) {
        this.description = phase.errorMessage;
      }
      this.errorMessage = phase.errorMessage;
    }
    this.size = 'large';
    this.children = new Array<Node>();
  }

  getPhaseDateString(): string {
    if (this.phase.publishStatus === EnumPipelineHandleStatus.Padding) {
      return '';
    }
    let result = DateHelper.format(this.phase.beginTime, 'HH:mm:ss');
    if (this.phase.publishStatus === EnumPipelineHandleStatus.Executing) {
      result += '，执行中...';
    }
    if (this.phase.publishStatus === EnumPipelineHandleStatus.Success || this.phase.publishStatus === EnumPipelineHandleStatus.Fail) {
      result += ', 共耗时 ' + (Math.abs(this.phase.beginTime.getTime() - this.phase.endTime.getTime()) / 1000).toFixed(0) + ' 秒';
    }
    return result;
  }

  getPhaseTypeString(): string {
    let result = '';
    switch (this.phase.publishStatus) {
      case EnumPipelineHandleStatus.Executing:
        result = 'primary';
        break;
      case EnumPipelineHandleStatus.Success:
        result = 'success';
        break;
      case EnumPipelineHandleStatus.Fail:
        result = 'danger';
        break;
      case EnumPipelineHandleStatus.Padding:
      default:
        break;
    }
    return result;
  }
}

@Component({
  components: {
  }
})
export default class ProductPublishHistory extends Vue {
  @Prop() publishTask!: PipelinePublishTask; // 最后一次发布任务
  @Prop() settingDTO!: ProductPipelineSettingDTO; // 最后一次发布设置
  private key = 0;
  private nodes: Array<Node>;

  constructor() {
    super();
    this.nodes = new Array<Node>();
  }

  mounted() {
    this.init();
  }

  init() {
    this.nodes = new Array<Node>();
    PipelineService.GetPublishPhasesByTaskAsync(this.publishTask.id)
      .then(res => {
        this.nodes.push(this.getTaskBeginNode());
        const allNodes = new Dictionary<string, Node>();
        res.forEach(phase => {
          const node = new Node(phase);
          allNodes.append(node.id, node);
        });
        res.forEach(phase => {
          if (phase.mainPhase_ID === null || phase.mainPhase_ID === '') {
            this.nodes.push(allNodes.getValue(phase.id));
          } else {
            const mainPhase = allNodes.getValue(phase.mainPhase_ID);
            if (mainPhase !== null) {
              mainPhase.children.push(allNodes.getValue(phase.id));
            }
          }
        });
        this.nodes.push(this.getTaskEndNode());
      });
  }

  get refreshKey() {
    return this.key;
  }

  getIncludeAPPs() {
    const includeAPPs = new Array<APP>();
    this.settingDTO.appList.forEach(app => {
      if (this.settingDTO.includeAppKeys.indexOf(app.aPPKey) > -1) {
        includeAPPs.push(app);
      }
    });
    return includeAPPs;
  }

  getTaskDateString(): string {
    let result = DateHelper.format(this.publishTask.publishOn);
    if (this.publishTask.publishStatus === EnumPipelineHandleStatus.Success || this.publishTask.publishStatus === EnumPipelineHandleStatus.Fail) {
      result += ' - ' + DateHelper.format(this.publishTask.finishOn, 'HH:mm:ss') + ', 共耗时 ' + (Math.abs(this.publishTask.publishOn.getTime() - this.publishTask.finishOn.getTime()) / 1000 / 60).toFixed(1) + ' 分钟';
    }
    return result;
  }

  getTaskBeginNode(): Node {
    let time = '';
    let type = '';
    if (this.publishTask.publishStatus === EnumPipelineHandleStatus.Padding) {
      time = '';
    } else {
      type = 'success';
      time = DateHelper.format(this.publishTask.publishOn);
    }
    const node = new Node(null);
    node.id = '1';
    node.timestamp = time;
    node.name = '开始执行流水线';
    node.description = '开始完整执行流水线';
    node.type = type;
    return node;
  }

  getTaskEndNode(): Node {
    let time = '';
    let type = '';
    if (this.publishTask.publishStatus !== EnumPipelineHandleStatus.Fail && this.publishTask.publishStatus !== EnumPipelineHandleStatus.Success) {
      time = '';
    } else {
      time = DateHelper.format(this.publishTask.finishOn);
      if (this.publishTask.publishStatus === EnumPipelineHandleStatus.Fail) {
        type = 'danger';
      } else {
        type = 'success';
      }
    }
    const node = new Node(null);
    node.id = '2';
    node.timestamp = time;
    node.name = '执行流水线结束';
    node.description = '结束流水线的完整执行，成功或者出错都是执行完成';
    node.type = type;
    return node;
  }

  showMessage(node: Node) {
    console.log(node);
  }

  getHandleStatus(): string {
    return EnumPipelineHandleStatusMD.getItemByValue(this.publishTask.publishStatus).displayName;
  }
}
